<template>
    <div class="oeetableapp">
        <!-- summary -->
        <Summary :item="data"></Summary>
        <!-- summary -->
        <BarChart :gid="gid" :width="width" @on-update-data="updateData"></BarChart>
    </div>
</template>
<script>
import Summary from './components/summary.vue';
import BarChart from './components/barChart.vue';

export default {
    name: 'oeetableapp',
    components: {
        Summary,
        BarChart
    },
    data() {
        return {
            gid: Number(this.$route.params.gid),
            width: Number(this.$route.params.width),
            data: {}
        };
    },
    methods: {
        updateData(data) {
            this.data = data;
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/views/oeetableapp/oeeTableApp.vue